export default function ThumbIcon({width, height}:{width?: string, height?: string}) {
  return (
    <svg
      
      width={width || "30"}
      height={height || "30"}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Adjust Range</title>
      <rect x="1" y="0.5" width="28" height="28" rx="14" fill="#131313" />
      <rect x="1" y="0.5" width="28" height="28" rx="14" stroke="#FBFBFB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.846 11.7064L20.2978 11.7156C20.6475 11.7161 20.8422 12.1135 20.6394 12.3896L20.6399 12.3901L13.2219 22.4581C12.9494 22.8288 12.3422 22.5601 12.4748 22.0808L14.1656 15.054H9.70982C9.37166 15.054 9.14244 14.6619 9.38507 14.3545L16.7857 4.31035C17.0582 3.93958 17.6651 4.20812 17.533 4.68737L15.846 11.7064Z"
        fill="#96FF43"
      />
    </svg>
  );
}
